import { GroupsEvent } from 'APP/Tasks/group/handleGroupEvents/GroupsEvent/GroupsEvent';
import { IChatMessagesTtlChangedPayloadResponse } from 'APP/model/counter/counterModel.types';
import Entities from 'STORE';

export class ChatMessagesTtlChanged extends GroupsEvent<IChatMessagesTtlChangedPayloadResponse> {
  process(): void {
    const { ttlPeriodMs = 0 } = this.eventPayload || {};
    const group = Entities.GroupsStore.getGroupById(this.groupId);

    if (!group) {
      return;
    }

    group.ttlPeriodMs = ttlPeriodMs;
  }
}
